<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、出入库调整</span>
        <span v-else>出入库调整</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <div style="padding-left: 16px;">
            <span class="desc">被调整库存：出入库{{ getInventoryNumber(item.inventory_id) }}</span>
            <span class="desc">仓库：{{ item.warehouse }}</span>
            <span class="desc" v-if="item.gross_weight">提货单毛量：{{ item.gross_weight }}</span>
            <span class="desc" v-if="item.net_weight">提货单净量：{{ item.net_weight }}</span>
            <span class="desc" v-if="item.weighing_capacity">过磅量：{{ item.weighing_capacity }}</span>
            <span class="desc" v-if="item.unit">单位：{{ dictionaries.unit[item.unit] }}</span>
            <span class="desc" v-if="item.unit_price_cny">预估人民币单价：{{ item.unit_price_cny }} </span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_inventory_adjustment', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'inventory_adjustment')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc">已调整：{{ item.is_adjustment ? '是' : '否' }}</span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
          </div>
          <div style="padding-left: 16px;" v-if="!item.is_archived && ((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)) && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'inventory_adjustment')">
                <span v-if="(item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)">删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_inventory_adjustment', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div>
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="1" header="附件" :style="customStyle" v-if="item.attachment.length > 0">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'InventoryAdjustmentInfo',
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    },
    projectContentList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      inventoryTypeList: [
        '入库',
        '出库',
        '平账'
      ],
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  computed: {
    sortedProjectContentList () {
      return [...this.projectContentList].sort((a, b) => new Date(a.create_time) - new Date(b.create_time))
    }
  },
  methods: {
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    },
    getInventoryNumber (inventory_id) {
      let index = 0
      this.sortedProjectContentList.forEach((item, i) => {
        if (item.id === inventory_id && item.content_type === 'inventory') {
          index = i + 1
        }
      })
      return index
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
